const gamesExcerptBlocksSetup = () => {
  const components = document.querySelectorAll('[data-component-games-excerpt-blocks]');
  components.forEach((component) => {
  });

  ScrollReveal().reveal('.games-excerpt-blocks', { origin: 'right', distance: '600px', delay: 800  });

};


gamesExcerptBlocksSetup();